import * as R from 'ramda';
import { connect } from 'react-redux';

import { TThunkDispatch, IReduxState } from '../../types/redux';
import { setMinLandArea, setMaxLandArea } from '../../actions/filters';
import { FilterLandArea, IFilterAreaProps } from '../../components/FilterLandArea';

type TFilterAreaStateProps = Pick<IFilterAreaProps, 'value'>;
type TFilterAreaDispatchProps = Pick<IFilterAreaProps, 'setMin' | 'setMax'>;

export function mapStateToProps(state: IReduxState): TFilterAreaStateProps {
  const { jsonQuery } = state.filters;

  return {
    value: R.pathOr({}, ['site', 'value'], jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterAreaDispatchProps {
  return {
    setMin: (value: number | undefined) => dispatch(setMinLandArea(value)),
    setMax: (value: number | undefined) => dispatch(setMaxLandArea(value)),
  };
}

export const FilterLandAreaContainer = connect(mapStateToProps, mapDispatchToProps)(FilterLandArea);
